import { MS_INBOX_PLATFORM_RETAILERS_PATH } from '../../constants/AppConstants';
import fetchWithTimeout from '../../util/fetchWithTimeout';
import { msInboxApiUrl, buildMsInboxAuthHeaders } from './msInboxClient';

/**
 * PUT mia-agent contra el microservicio inbox: asigna (o, con `null`, desasigna) el agente
 * MIA de un platform_retailer. No pasa por MercatelyModel: su manejo de 401 desloguea de
 * Mercately ante un fallo del MS (`core/MercatelyModel.js`), y aquí un 401 del MS no debe
 * tumbar la sesión del monolito.
 *
 * @param {string|number} platformRetailerId
 * @param {string|number|null} miaAgentId
 */
export async function setMiaAgentMsInbox(platformRetailerId, miaAgentId) {
  const url = msInboxApiUrl(`${MS_INBOX_PLATFORM_RETAILERS_PATH}/${platformRetailerId}/mia-agent`);
  const headers = await buildMsInboxAuthHeaders();

  const response = await fetchWithTimeout(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ mia_agent_id: miaAgentId == null ? null : String(miaAgentId) }),
    mode: 'cors'
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    const errorMessage = errorDetails.message
      || errorDetails.error
      || errorDetails?.errors
      || `HTTP error! Status: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return response.json().catch(() => null);
}
